import DateRangePicker from '@wojtekmaj/react-daterange-picker';
import '@wojtekmaj/react-daterange-picker/dist/DateRangePicker.css';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import 'react-calendar/dist/Calendar.css';
import DataTable from 'react-data-table-component';
import IconCalendar from '../../assets/SidebarIcons/icon-calendar-time.svg';
import { downloadFile, getRequest } from '../../helpers/apiHandler';

import './_smsTransaction.scss';

const white_label_perkeso = process.env.REACT_APP_WHITE_LABEL_PERKESO === 'true';

const SMSreportModal = ({ show, onClose, access_token, user_id, date, setDate }) => {
  const [loadingData, setLoadingData] = useState(false);
  const [loadingDownload, setLoadingDownload] = useState(false);
  const [search, setSearch] = useState('');
  const [data, setData] = useState([]);
  const [columns, setColumns] = useState([]);

  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [totalPages, setTotalPages] = useState(0);

  const [alertState, setAlertState] = useState({
    show: false,
    variant: 'danger',
    message: '',
  });

  const getSMSReportData = () => {
    setLoadingData(true);
    const payload = {
      headers: { Authorization: access_token.token },
      params: {
        start_date: date[0] ? moment(date[0]).format('YYYY-MM-DD HH:mm:ss.SSSSSS') : null,
        end_date: date[1] ? moment(date[1]).format('YYYY-MM-DD HH:mm:ss.SSSSSS') : null,
        page: currentPage,
        limit: rowsPerPage,
        emails: search || null,
        user_id: user_id || null,
      },
    };

    getRequest(`/admin/sms-report`, payload, (res) => {
      if (res.success) {
        setData(res.data.sms_data || []);
        setTotalRecords(res.data.total_records || 0);
        setTotalPages(res.data.pages || 0);
      } else {
        setAlertState({
          message: res.message,
          show: true,
          variant: 'danger',
        });
      }
      setLoadingData(false);
    });
  };

  const handlePageChange = (page) => {
    if (page > 0 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  const handleRowsPerPageChange = (newRowsPerPage) => {
    setRowsPerPage(newRowsPerPage);
    setCurrentPage(1);
  };

  const generateColumns = () => {
    return [
      { name: 'Date', sortable: true, selector: (row) => row.date },
      { name: 'Trx ID', sortable: true, selector: (row) => row.transaction_id },
      { name: 'Message', sortable: true, selector: (row) => row.message },
      { name: 'Trx Count', sortable: true, selector: (row) => row.transaction_count },
      { name: 'Country', sortable: true, selector: (row) => row.country },
      { name: 'Phone', sortable: true, selector: (row) => row.phone_number },
      ...(!white_label_perkeso ? [
        { name: 'Cost', sortable: true, selector: (row) => row.cost }
      ] : []),
      { name: 'Status', sortable: true, selector: (row) => row.status },
    ];
  };

  const onSearch = (evt) => {
    setSearch(evt.target.value);
  };

  const downloadReport = () => {
    setLoadingDownload(true);

    downloadFile(
      {
        url: '/admin/sms-report-download',
        data: {
          sms_data: data,
        },
        access_token: access_token,
        fileName: `SMS-Report.csv`,
      },
      (res) => {
        setLoadingDownload(false);
        if (res.success) {
          setAlertState({
            message: 'Your sms report have been successfully exported to csv.',
            show: true,
            variant: 'success',
          });
        } else {
          setAlertState({
            message:
              'We apologize, but it seems there was an issue exporting your analytics to csv.',
            show: true,
            variant: 'danger',
          });
        }
      }
    );
  };

  useEffect(() => {
    setColumns(generateColumns());
  }, []);

  useEffect(() => {
    if (user_id) {
      getSMSReportData();
    }
  }, [currentPage, rowsPerPage, date, search, user_id]);

  return (
    <Modal show={show} onHide={onClose} size="xl">
      <Modal.Header closeButton>
        <div className="w-100 d-flex justify-content-between align-items-center">
          <Modal.Title>SMS Report of User ID: {user_id}</Modal.Title>
          <div className="d-flex gap-2">
            <DateRangePicker
              value={date}
              onChange={setDate}
              clearIcon={null}
              calendarIcon={<img src={IconCalendar} alt="..." />}
              format="MM-dd-y"
              rangeDivider={<i className="fas fa-long-arrow-alt-right" />}
              dayPlaceholder="DD"
              monthPlaceholder="MM"
              yearPlaceholder="YYYY"
            />

            <Button onClick={() => downloadReport()}>Export to excel</Button>
          </div>
        </div>
      </Modal.Header>

      <Modal.Body>
        <div className="w-100" style={{ padding: 30 }}>
          <DataTable
            columns={columns}
            data={data}
            progressPending={loadingData}
            pagination
            paginationServer // Enable server-side pagination
            paginationTotalRows={totalRecords}
            onChangeRowsPerPage={handleRowsPerPageChange}
            onChangePage={handlePageChange}
            paginationComponentOptions={{
              rowsPerPageText: 'Items per page:',
            }}
          />
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default SMSreportModal;
